import React, { useState } from "react";
import dashboard from "../styles/dashboard.module.css";
import "../styles/global.css";
import { useNavigate } from "react-router";
import folderIcon from "../assets/img/ICON_ALIADAS/FOLDER/FOLDER-#37285f.png";
import folderIconDM from "../assets/img/ICON_ALIADAS/FOLDER/FOLDER_WHITE.png";
import { AppThemeProvider, useTheme } from "../context/AppThemeContext";
import { useFolderTree } from "../context/FolderTreeContext";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";






type Folder = {
  id: number;
  name: string;
  children?: Folder[];
};

type FolderNodeProps = {
  folder: Folder;
  level: number;
};

const FolderNode: React.FC<FolderNodeProps> = ({ folder, level }) => {
  const hasChildren = folder.children && folder.children.length > 0;
  const navigate = useNavigate();
  const { isNight } = useTheme();
  const { isFolderOpen, toggleFolder } = useFolderTree();
  const isOpen = isFolderOpen(folder.id);

  const folderActual = isNight ? folderIconDM : folderIcon;

  const handleClick = () => {
    if (hasChildren) {
      toggleFolder(folder.id);
    }
  };

  const handleDoubleClick = () => {
    navigate(`/dashboardfolder/${folder.id}`);
  };

  return (
    <li className={`${dashboard.folderItem}`}>
      <div onClick={handleClick} onDoubleClick={handleDoubleClick} className="modonocheP">
        <span className={dashboard.arrowFolder}>
          {hasChildren && (isOpen ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />)}
        </span>
        <img src={folderActual} className={dashboard.iconosfila} alt="Modo Día/Noche" /> {folder.name}
      </div>

      {isOpen && hasChildren && (
        <ul className={dashboard.folderList}>
          {folder.children!.map((child, index) => (
            <FolderNode key={index} folder={child} level={level + 1} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default FolderNode;
